<template>
  <div class="fixed-top menucontrol-scroll">
    <Banner />
    <ManagementCards />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import ManagementCards from "./components/ManagementCards.vue";
export default {
  components: {
    Banner,
    ManagementCards,
  },
};
</script>
